import React from 'react';
import FadeIn from "../../../../helpers/FadeIn";
import CircleSkeleton from "../../../../helpers/Loaders/CircleSkeleton";
import RectangleSkeleton from "../../../../helpers/Loaders/RectangleSkeleton";
import styles from '../../ProfileHeader.module.scss';
const ProfileHeaderLoader = ({ shouldRenderUsername = true, }) => {
    return (React.createElement(FadeIn, { className: styles.wrapper },
        React.createElement(CircleSkeleton, { className: styles.circleSizing }),
        shouldRenderUsername && (React.createElement(RectangleSkeleton, { className: styles.userName, width: "96px", height: "20px" }))));
};
export default ProfileHeaderLoader;
//# sourceMappingURL=ProfileHeaderLoader.js.map